module.exports = __webpack_public_path__ + "static/img/addService4.6cb2ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceExperience/addService4.png
// module id = XXvb
// module chunks = 1